module.exports = __webpack_public_path__ + "platform/static/media/person.17ac6537.svg";